import { useRouteLoaderData } from '@remix-run/react';

import { SubscriberGate } from '~/components/Actions/types';
import Signup from '~/components/Signup';

import type { Price } from '~/interfaces/subscriptions';
import type { UpgradePage } from '~/interfaces/upgrade_page';

interface FreeTrialFormProps {
  onContinue: () => void;
  price?: Price;
  premiumOfferId: string;
  upgradePage: UpgradePage;
}

// biome-ignore lint/correctness/noUnusedVariables: Keeping for backwards compatibility
const FreeTrialForm = ({ onContinue, price, premiumOfferId, upgradePage }: FreeTrialFormProps) => {
  const { signupWidgetConfigs } = useRouteLoaderData<any>('root');

  return (
    <Signup
      signupStyles={{
        ...signupWidgetConfigs,
      }}
      premiumOfferId={premiumOfferId}
      type={SubscriberGate.FORM}
      onSuccess={onContinue}
    />
  );
};

export default FreeTrialForm;
